import script from "./NumberTagsList.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberTagsList.vue?vue&type=script&setup=true&lang=js"

import "./NumberTagsList.vue?vue&type=style&index=0&id=20c0b390&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20c0b390"]])

export default __exports__